import { Actions } from 'vuex-smart-module';
import { PurchaseOrdersService } from '@/modules/purchase-orders/services';
import { EquipmentRequest } from '@/modules/purchase-orders/types';
import EquipmentState from './state';
import EquipmentMutations from './mutations';
import EquipmentGetters from './getters';

const purchaseOrdersService = new PurchaseOrdersService();

export default class EquipmentActions extends Actions<
  EquipmentState,
  EquipmentGetters,
  EquipmentMutations,
  // eslint-disable-next-line no-use-before-define
  EquipmentActions
> {
  async get_equipment(id: string | number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: EquipmentRequest = {
        filters: [],
        filters_exist: true,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_EQUIPMENT(true);
      const { data, meta } = await purchaseOrdersService.get_equipment(id, payload);

      this.mutations.SET_EQUIPMENT(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_EQUIPMENT(false);
    }
  }
}
